import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeficiencyModel } from 'src/app/models/deficiency.model';
import { environment } from 'src/environments/environment';
import { NotesServiceInterface } from './notes.interface';

@Injectable({
  providedIn: 'root'
})
export class NotesService implements NotesServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetAllDeficienciesByCourseApprovalId(courseApprovalId,phaseId=1,version=0): Observable<DeficiencyModel[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Notes/GetDeficienciesForPublicPortal/${courseApprovalId}/null/${phaseId}/${version}`);
  }

  GetAllFieldChecklistDeficienciesByCourseApprovalId(courseApprovalId,phaseId=3,version=-1): Observable<DeficiencyModel[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Notes/GetDeficienciesForPublicPortal/${courseApprovalId}/PreFieldAssessmentChecklist/${phaseId}/${version}`);
  }

  SaveDeficiencyResponse(def: DeficiencyModel): Observable<DeficiencyModel> { 
    return this.httpClient.post<any>(environment.apiBaseUrl + `Notes/SaveDeficiencyResponse`, def);
  }

  SaveDeficiency(def: DeficiencyModel, documentMetadataId:string =''): Observable<DeficiencyModel> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `Notes/SaveDeficiencyForPublicPortal/${documentMetadataId}`, def);
  }

  DeleteDeficiencyResponse(defId: string): Observable<any> {
    return this.httpClient.delete<any>(environment.apiBaseUrl + `Notes/DeleteDeficiencyResponse/${defId}`);
  }
}
